export const SET_TAX_SETTINGS = 'SET_TAX_SETTINGS'
export const SET_TAX_CONFIGURATION = 'SET_TAX_CONFIGURATION'
export const SET_TAX_DIVIDE_CONFIGURATION = 'SET_TAX_DIVIDE_CONFIGURATION'
export const SET_BUSINESS_TAX_CONFIGURATIONS = 'SET_BUSINESS_TAX_CONFIGURATIONS'
